<template>
	<div>
	<review-create-modal
	ref="reviewCreateModal"
	:project-id="itemId"
	v-on:refetch="refetch"
	/>

	<card-component
	ref="card"
	:key="itemId"
	:model="['project_other', 'projects_other']"
	:id="itemId"
	:required-fields="requiredFields"
	:fields-list="[
		'title',
		'project_type',
		'approver',
		'approver_branches',
		'charge_departments',
		'incoming_date',
		'incoming_number',
		'notes',
		'applicant',
		'applicant_branch',
		'applicant_individual',
		'applicant_json',
		'customer',
		'customer_branch',
		'customer_individual',
		'customer_json',
		'regions',
		'municipalities',
		'waterobjects',
		'waterbasins',
		'review_notes',
		'related_projects',
		'parents_projects',
		'project_periods'
	]"
	:fields-prefill="[
		['approver', $store.getters.department_access_main ? $store.getters.department_access_main.department_id : null]
	]"
	delete-message="Подтвердите удаление согласования в корзину"
	restore-message="Подтвердите восстановление согласования из корзины"
	:enable-tags="$store.getters.permissions.includes('enable_tagging')"
	v-on:refetch="refetch"
	@callback="arguments[0]()"
	:custom-buttons="[
		{
			text: 'Добавить решение',
			callback: () => $refs.reviewCreateModal.openModal(),
			icon: 'file-contract',
			variant: 'success',
			visibleIf: (item) => item.is_acceptable || item.is_declinable
		}
	]"
	>
	<template v-slot:card="slotProps">
		<div class="card-body d-flex flex-wrap">

			<!-- Все статусы и информационные сообщения Согласования -->
			<div
			v-if="slotProps.editableItem.status_review || slotProps.editableItem.status_data"
			class="d-flex flex-wrap gap-2 mb-3"
			>
				<template v-for="statusItem in [slotProps.editableItem.status_review, ...slotProps.editableItem.status_data]">
					<component
					:is="statusItem.url ? 'router-link' : 'div'"
					:to="statusItem.url"
					class="alert border-0 d-flex align-items-center px-3 py-2 m-0 font-size-14 text-decoration-none"
					:class="'alert-' + statusItem.color"
					>
						<span class="far fa-fw mr-1" :class="'fa-' + statusItem.icon"></span><span :style="statusItem.url ? 'text-decoration: underline;' : ''">{{ statusItem.text }}</span>
					</component>
				</template>
			</div>

			<div class="d-flex flex-wrap w-100">
				<!-- ПЕРВАЯ КОЛОНКА БАЗОВАЯ ИНФОРМАЦИЯ -->
				<div class="col-lg-4 col-md-12 col-sm-12 p-3">
					<h6 class="text-form-header mb-3 d-flex justify-content-between">
						<span class="text-truncate">
							<span class="fal fa-inbox-in fa-fw lead align-self-center"></span> Сведения о документации <span class="badge badge-light">{{ slotProps.item.id }}</span>
						</span>
					</h6>
					
					<card-field-component
					type="textarea"
					title="Наименование деятельности"
					fieldname="title"
					:errors="slotProps.errors"
					v-model="slotProps.editableItem.title"
					:display-value="slotProps.item.title"
					:disabled="slotProps.fetching"
					:mode="slotProps.mode"
					v-on:update:value="slotProps.editableItem.title = $event"
					:is-required="requiredFields.some(o => o[0] === 'title')"
					/>

					<card-field-component
					type="select"
					title="Тип деятельности"
					fieldname="project_type"
					:errors="slotProps.errors"
					v-model="slotProps.editableItem.project_type"
					:display-value="slotProps.item.project_type"
					:mode="slotProps.mode"
					:options="availableProjectTypes"
					v-on:update:value="slotProps.editableItem.project_type = $event"
					:is-required="requiredFields.some(o => o[0] === 'project_type')"
					/>

					<card-field-component
					v-if="slotProps.editableItem.project_type == 'Согласование условий водопользования'"
					type="select"
					title="Тип водопользования"
					fieldname="project_subtype"
					:errors="slotProps.errors"
					v-model="slotProps.editableItem.project_subtype"
					:display-value="slotProps.item.project_subtype"
					:disabled="slotProps.fetching"
					:mode="slotProps.mode"
					:options="[
						'Нет',
						'Забора (изъятия) водных ресурсов из водных объектов в соответствии с частью 3 статьи 38 Водного кодекса Российской Федерации',
						'Использования акватории водных объектов, необходимой для эксплуатации судоремонтных и судостроительных сооружений и занятой гидротехническими сооружениями',
						'Использования акватории водных объектов для лечебных и оздоровительных целей санаторно-курортными организациями',
						'Использования акватории водных объектов для эксплуатации пляжей правообладателями земельных участков, находящихся в государственной или муниципальной собственности и расположенных в границах береговой полосы водного объекта общего пользования, а также для рекреационных целей физкультурно-спортивными организациями, туроператорами или турагентами, осуществляющими свою деятельность в соответствии с федеральными законами, организованного отдыха детей, ветеранов, граждан пожилого возраста, инвалидов',
						'Производства электрической энергии без забора (изъятия) водных ресурсов из водных объектов',
						'Обеспечения обороны страны и безопасности государства',
						'Сброса сточных вод',
						'Строительства и реконструкции гидротехнических сооружений',
						'Создания стационарных и плавучих (подвижных) буровых установок (платформ), морских плавучих (передвижных) платформ, морских стационарных платформ и искусственных островов',
						'Строительства и реконструкции мостов, подводных переходов, трубопроводов и других линейных объектов, если такие строительство и реконструкция связаны с изменением дна и берегов поверхностных водных объектов',
						'Разведки и добычи полезных ископаемых',
						'Проведения дноуглубительных, взрывных, буровых и других работ, связанных с изменением дна и берегов поверхностных водных объектов, за исключением случаев, предусмотренных частью 2 статьи 47 Водного кодекса Российской Федерации',
						'Подъема затонувших судов',
						'Сплава древесины',
						'Забора (изъятия) водных ресурсов из водных объектов для гидромелиорации земель',
						'Забора (изъятия) водных ресурсов из водных объектов и сброса сточных вод для осуществления аквакультуры (рыбоводства)',
						'Предоставление водного объекта в пользование на основании договора водопользования, право на заключение которого приобретается на аукционе'
					]"
					v-on:update:value="slotProps.editableItem.project_subtype = $event"
					:is-required="requiredFields.some(o => o[0] === 'project_subtype')"
					/>

					<card-field-component
					type="entity:department"
					title="Согласователь"
					fieldname="approver"
					:errors="slotProps.errors"
					v-model="slotProps.editableItem.approver"
					:disabled="slotProps.fetching"
					:mode="slotProps.mode"
					v-on:update:value="slotProps.editableItem.approver = $event"
					:is-required="requiredFields.some(o => o[0] === 'approver')"
					/>

					<div class="row my-3">
						<card-field-component
						class="col-6"
						:no-margin="true"
						type="date"
						title="Дата поступления"
						help-tooltip="Следует указать дату входящего письма присвоенного Управлением"
						fieldname="incoming_date"
						:errors="slotProps.errors"
						v-model="slotProps.editableItem.incoming_date"
						:display-value="slotProps.item.incoming_date"
						:disabled="slotProps.fetching"
						:mode="slotProps.mode"
						v-on:update:value="slotProps.editableItem.incoming_date = $event"
						:is-required="requiredFields.some(o => o[0] === 'incoming_date')"
						/>

						<card-field-component
						class="col-6"
						:no-margin="true"
						type="text"
						title="Вх. номер"
						help-tooltip="Следует указать номер входящего письма присвоенного Управлением"
						fieldname="incoming_number"
						:errors="slotProps.errors"
						v-model="slotProps.editableItem.incoming_number"
						:display-value="slotProps.item.incoming_number"
						:disabled="slotProps.fetching"
						:mode="slotProps.mode"
						v-on:update:value="slotProps.editableItem.incoming_number = $event"
						:is-required="requiredFields.some(o => o[0] === 'incoming_number')"
						/>
					</div>

					<card-field-component
					type="project_periods"
					title="Сроки проекта"
					fieldname="project_periods"
					:errors="slotProps.errors"
					v-model="slotProps.editableItem.project_periods"
					:display-value="false"
					:disabled="slotProps.fetching"
					:mode="slotProps.mode"
					v-on:update:value="slotProps.editableItem.project_periods = $event"
					:is-required="requiredFields.some(o => o[0] === 'project_periods')"
					/>

					<card-field-component
					type="textarea"
					title="Заметка о документации"
					fieldname="notes"
					:errors="slotProps.errors"
					v-model="slotProps.editableItem.notes"
					:display-value="slotProps.item.notes"
					:disabled="slotProps.fetching"
					:mode="slotProps.mode"
					v-on:update:value="slotProps.editableItem.notes = $event"
					:is-required="requiredFields.some(o => o[0] === 'notes')"
					/>

				</div>
				<!-- ВТОРАЯ КОЛОНКА ОРГАНИЗАЦИИ ГЕОДАННЫЕ -->
				<div class="col-lg-4 col-md-6 col-sm-12 p-3">
					<h6 class="text-form-header mb-3 d-flex justify-content-between">
						<span class="text-truncate">
							<span class="fal fa-building fa-fw lead align-self-center"></span> Субъекты деятельности
						</span>
					</h6>

					<card-field-component
					type="organization_data"
					title="Заявитель"
					fieldname="applicant_json"
					:errors="slotProps.errors"
					v-model="slotProps.editableItem.applicant_json"
					:display-value="slotProps.item.applicant_json"
					:fallback-value="{	
						organization: slotProps.editableItem.applicant,
						organization_branch: slotProps.editableItem.applicant_branch,
						individual: slotProps.editableItem.applicant_individual
					}"
					:disabled="slotProps.fetching"
					:mode="slotProps.mode"
					v-on:update:value="slotProps.editableItem.applicant_json = $event"
					:is-required="requiredFields.some(o => o[0] === 'applicant_json')"
					/>

					<card-field-component
					type="organization_data"
					title="Водопользователь"
					fieldname="customer_json"
					:errors="slotProps.errors"
					v-model="slotProps.editableItem.customer_json"
					:display-value="slotProps.item.customer_json"
					:disabled="slotProps.fetching"
					:mode="slotProps.mode"
					v-on:update:value="slotProps.editableItem.customer_json = $event"
					:is-required="requiredFields.some(o => o[0] === 'customer_json')"
					/>

					<hr>

					<h6 class="text-form-header mb-3 d-flex justify-content-between">
						<span class="text-truncate">
							<span class="fal fa-map fa-fw lead align-self-center"></span> Сведения о местоположении
						</span>
					</h6>

					<card-field-component
					type="entity:region"
					title="Регионы"
					fieldname="regions"
					:errors="slotProps.errors"
					v-model="slotProps.editableItem.regions"
					:disabled="slotProps.fetching"
					:mode="slotProps.mode"
					:multiple-entities="true"
					v-on:update:value="slotProps.editableItem.regions = $event"
					:is-required="requiredFields.some(o => o[0] === 'regions')"
					/>

					<card-field-component
					type="entity:municipality"
					title="Муниципальные образования"
					fieldname="municipalities"
					:errors="slotProps.errors"
					v-model="slotProps.editableItem.municipalities"
					:disabled="slotProps.fetching"
					:mode="slotProps.mode"
					:multiple-entities="true"
					v-on:update:value="slotProps.editableItem.municipalities = $event"
					:is-required="requiredFields.some(o => o[0] === 'municipalities')"
					/>

					<card-field-component
					type="entity:waterobject"
					title="Водные объекты"
					fieldname="waterobjects"
					:errors="slotProps.errors"
					v-model="slotProps.editableItem.waterobjects"
					:disabled="slotProps.fetching"
					:mode="slotProps.mode"
					:multiple-entities="true"
					v-on:update:value="slotProps.editableItem.waterobjects = $event"
					:is-required="requiredFields.some(o => o[0] === 'waterobjects')"
					/>

					<card-field-component
					type="text"
					title="Координаты"
					fieldname="coordinates"
					:errors="slotProps.errors"
					v-model="slotProps.editableItem.coordinates"
					:disabled="slotProps.fetching"
					:mode="slotProps.mode"
					:multiple-entities="true"
					v-on:update:value="slotProps.editableItem.coordinates = $event"
					:is-required="requiredFields.some(o => o[0] === 'coordinates')"
					/>

				</div>
				<!-- ТРЕТЬЯ КОЛОНКА СТАТУСЫ ФАЙЛЫ -->
				<div class="col-lg-4 col-md-6 col-sm-12 p-3">
					<h6 class="text-form-header mb-3">
						<span class="fal fa-file-contract fa-fw lead"></span> 
						Решения
					</h6>
					<div v-if="slotProps.editableItem.project_review">
						<review-card 
						:review="slotProps.editableItem.project_review" 
						v-on:refetch="refetch"
						type="project"
						/>
					</div>
					<div v-else>
						В ожидании
					</div>
					<br>

					<card-field-component
					class=""
					type="textarea"
					title="Заметка о согласовании"
					fieldname="review_notes"
					:errors="slotProps.errors"
					v-model="slotProps.editableItem.review_notes"
					:display-value="slotProps.item.review_notes"
					:disabled="slotProps.fetching"
					:mode="slotProps.mode"
					v-on:update:value="slotProps.editableItem.review_notes = $event"
					:is-required="requiredFields.some(o => o[0] === 'review_notes')"
					/>

					<template v-if="slotProps.editableItem.project_type === 'Согласование нормативов допустимых сбросов'">
						<card-field-component
						type="checkbox"
						title="КЭР"
						checkbox-label="Есть"
						fieldname="is_complex_nds"
						:errors="slotProps.errors"
						help-tooltip="Комплексное экологическое разрешение"
						v-model="slotProps.editableItem.is_complex_nds"
						:display-value="slotProps.item.is_complex_nds"
						:disabled="slotProps.fetching"
						:mode="slotProps.mode"
						v-on:update:value="slotProps.editableItem.is_complex_nds = $event"
						:is-required="requiredFields.some(o => o[0] === 'is_complex_nds')"
						/>
					</template>

					<div class="">
						<!-- СВЯЗИ -->
						<h6 class="text-form-header mb-2">
							<span class="fal fa-link fa-fw lead"></span> Связанные согласования
						</h6>
						
						<card-field-component
						type="entity:project"
						title="Ссылки на другие согласования"
						v-model="slotProps.editableItem.related_projects"
						:disabled="slotProps.fetching"
						:mode="slotProps.mode"
						:multiple-entities="true"
						:max-length="120"
						v-on:update:value="slotProps.editableItem.related_projects = $event"
						:is-required="requiredFields.some(o => o[0] === 'related_projects')"
						/>

						<card-field-component
						type="entity:project"
						title="Ссылки на это согласование из других согласований"
						v-model="slotProps.editableItem.parents_projects"
						:disabled="slotProps.fetching"
						:mode="'show'"
						:multiple-entities="true"
						:max-length="120"
						v-on:update:value="slotProps.editableItem.parents_projects = $event"
						:is-required="requiredFields.some(o => o[0] === 'parents_projects')"
						/>
						
					</div>
				</div>
			</div>

		</div>
	</template>
	<template v-slot:files="slotProps">
		<div class="card-footer">
				
			<h6 class="text-form-header mb-2 d-flex justify-content-between">
				<span class="text-truncate">
					<span class="fal fa-paperclip fa-fw lead align-self-center"></span> Файлы
					<span class="badge badge-primary" v-if="slotProps.editableItem.media && slotProps.editableItem.media.length" v-text="slotProps.editableItem.media.length"></span>
				</span>
			</h6>

			<div class="row">
				<media-collection
				class="my-3 col-lg-4 col-md-6 col-sm-12"
				title="Заявка"
				:files="slotProps.item.media"
				:uploads="slotProps.uploads"
				:removed="slotProps.removed"
				:collection-name="'default'"
				:disabled="slotProps.fetching"
				:mode="slotProps.mode"
				/>
			</div>

		</div>
	</template>
	

	</card-component>

	</div>
</template>

<script>
import ReviewCreateModal from '@/views/reviews/ReviewCreateModal'
import ReviewCard from '@/views/reviews/ReviewCard'
import moment from 'moment'
export default {
	data () {
		return {
			mounted: false,
			moment: moment,
		}
	},
	components: {
		'review-create-modal': ReviewCreateModal,
		'review-card': ReviewCard
	},
	mounted() {
		this.mounted = true
	},
	computed: {
		itemId () {
			return this.$route.params.id
		},
		profile () {
			return this.$store.getters.profile
		},
		accessDepartments () {
			if (this.profile && this.profile.access_departments && this.profile.access_departments.length) {
				return this.profile.access_departments[0]
			}
			return null
		},
		accessDepartmentBranches () {
			if (this.profile && this.profile.access_department_branches && this.profile.access_department_branches.length) {
				return this.profile.access_department_branches[0]
			}
			return null
		},
		availableProjectTypes () {
			var arr = []

			if (this.$store.getters.permissions.includes('enable_nds_projects_list')) {
				arr.push('Согласование нормативов допустимых сбросов')
			}

			if (this.$store.getters.permissions.includes('enable_wateruse_projects_list')) {
				arr.push('Согласование условий водопользования')
			}

			return arr
		},
		requiredFields () {
			/**
			 * Определние полей необходимых к заполнению.
			 * Флаг mounted в data используется чтобы запустить вычислениие после того
			 * как карточка будет смонтирована
			 */
			if (!this.mounted) {
				return []
			} else {
				return [
					['title', 'Наименование', 3],
					['project_type', 'Тип деятельности'],
					['approver', 'Согласователь'],
					['incoming_date', 'Дата поступления'],
					['incoming_number', 'Входящий номер']
				]	
			}
		}
	},
	methods: {
		refetch () {
			this.$emit('refetch')
			this.$refs.card.fetchData()
		}
	}
}
</script>